import React from 'react';
import { Tag } from 'antd';

const STATUS_MAP = {
  draft: { color: 'default', text: '草稿' },
  pre_released: { color: 'purple', text: '已预发布' },
  released: { color: 'success', text: '已发布' },
};

const ReleaseTypeMap = {
  major: { color: 'red', text: 'Major' },
  minor: { color: 'blue', text: 'Minor' },
  patch: { color: 'green', text: 'Patch' },
};

export function StatusBadge({ status }) {
  const config = STATUS_MAP[status] || { color: 'default', text: status };
  return <Tag color={config.color}>{config.text}</Tag>;
}

export function ReleaseTypeBadge({ type }) {
  const config = ReleaseTypeMap[type] || { color: 'default', text: type };
  return <Tag color={config.color}>{config.text}</Tag>;
}

export function FeatureTypeBadge({ type }) {
  const map = {
    new_feature: { color: 'blue', text: '新功能' },
    improvement: { color: 'purple', text: '改进' },
    bugfix: { color: 'orange', text: '修复' },
  };
  const config = map[type] || { color: 'default', text: type };
  return <Tag color={config.color}>{config.text}</Tag>;
}
